import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { FunctionService  } from 'vhobjects-service';

@Pipe({
  name: 'vhLanguage',
})
export class VhLanguagePipe implements PipeTransform {

  constructor(
    private functionService: FunctionService
  ) { }

  /**
   * Hàm này sẽ trả về giá trị hiển thị hoặc giá trị mặc định từ functionService.multiLanguageFallback.
   * 
   * Nếu không có `fieldName` VÀ `component` thì sẽ trả về ''.
   * 
   * Nếu không có `fieldName` HOẶC `component` thì sẽ trả về 'Content'.
   * 
   * @param data gái trị sẽ hiển thị 
   * @param fieldName tên trường dữ liệu để khi fallback thì dùng nó để lấy gái trị mặc định từ functionService.multiLanguageFallback
   * @param component tên component để khi fallback thì dùng nó để lấy gái trị mặc định từ functionService.multiLanguageFallback 
   * @returns giá trị hiển thị hoặc giá trị mặc định từ functionService.multiLanguageFallback 
   * 
   * @example
   * staticdata['content_' + this.functionService.selectedLanguageCode] | vhLanguage : 'content' : data.component
   * 
   * data.staticdata['input_text_placeholder_' + this.functionService.selectedLanguageCode] | vhLanguage
   * 
   */
  transform(data: any, fieldName?: any, component?: any): any {
    if (data !== undefined && data !== null) {
      return data;
    }
    if (!fieldName && !component) {
      return '';
    }
    if (!fieldName || !component) {
      return 'Content';
    }
    return this.functionService.multiLanguageFallback[component]?.[fieldName] ?? 'Content';
  }

}


@NgModule({
  declarations: [VhLanguagePipe],
  imports: [
  ],
  exports: [VhLanguagePipe],

})
export class VhLanguagePipeModule { }